import {
    FORM_SET_FIELD_VALUE, FORM_SET_FIELD_VALIDATION, FORM_SET_EDITABLE_STATE, FORM_DISCARD_CHANGES, FORM_RECEIVE_DATA,
    FORM_SAVE_DATA, FORM_FETCHING_ERROR, FORM_SAVING_ERROR, FORM_FETCH_IN_PROGRESS, FORM_SAVE_IN_PROGRESS,
    FORM_INVALIDATE_FIELDS, FORM_RESET, FORM_REPOPULATE
} from 'state/actions/shared_form_actions';
// import axios from "axios";

export const getFormDefaultState = (fieldsTranspiler, fieldsData={}, dataToStore={}) => ({
    editable: false, // true, false
    storedData: dataToStore,
    fetchingData: false,
    savingData: false,
    fields: fieldsTranspiler(fieldsData)
});

export const processFormActions = (state, action, formName, dataTranspiler) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case FORM_SET_FIELD_VALUE:
            newState[action.formName]['fields'][action.fieldName]['value'] = action.value;
            return newState;
        case FORM_SET_FIELD_VALIDATION:
            newState[action.formName]['fields'][action.fieldName]['valid'] = action.validationStatus;
            return newState;
        case FORM_SET_EDITABLE_STATE:
            newState[action.formName]['editable'] = action.isEditable;
            return newState;
        case FORM_DISCARD_CHANGES:
            newState[action.formName]['fields'] = dataTranspiler(newState[action.formName]['storedData']);
            // newState[action.formName]['savingData'] = false;
            return newState;
        case FORM_FETCH_IN_PROGRESS:
            newState[action.formName]['fetchingData'] = true;
            return newState;
        case FORM_SAVE_IN_PROGRESS:
            newState[action.formName]['savingData'] = true;
            return newState;
        case FORM_FETCHING_ERROR:
            newState[action.formName]['fetchingData'] = false;
            return newState;
        case FORM_SAVING_ERROR:
            newState[action.formName]['fields'] = dataTranspiler(newState[action.formName]['storedData']);
            newState[action.formName]['savingData'] = false;
            return newState;
        case FORM_RECEIVE_DATA:
            newState[action.formName]['storedData'] = action.formData;
            newState[action.formName]['fields'] = dataTranspiler(action.formData);
            newState[action.formName]['fetchingData'] = false;
            return newState;
        case FORM_SAVE_DATA:
            newState[action.formName]['storedData'] = action.formData;
            newState[action.formName]['fields'] = dataTranspiler(action.formData);
            newState[action.formName]['savingData'] = false;
            return newState;
        case FORM_INVALIDATE_FIELDS:
            newState[action.formName]['savingData'] = false;
            newState[action.formName]['fields'] = invalidateFields(newState[action.formName]['fields']);
            return newState;
        case FORM_RESET:
            newState[action.formName] = getFormDefaultState(dataTranspiler, {}, newState[action.formName]['storedData']);
            return newState;
        case FORM_REPOPULATE:
            newState[action.formName] = getFormDefaultState(dataTranspiler, newState[action.formName]['storedData'], newState[action.formName]['storedData']);
            return newState;
        default:
            return state;
    }
};

export const isFormValid = fields => {
    for (let fieldName in fields) { if(!fields[fieldName]['valid']) return null; }
    return true;
};

const invalidateFields = fields => {
    const invalidatedFields = {};
    for (let [fieldName, fieldStatus] of Object.entries(fields)) {
        const {value, valid} = fieldStatus;
        invalidatedFields[fieldName] = { value, valid: !!valid }
    }
    return invalidatedFields;
};
//this is used in paymentinfo component to create formData for backend calls
export const createFormDataBlobWithFile = (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(item =>{
        if(!!data[item])formData.append(item, data[item]);
    });

    return formData
};